export const normalizeClientCode = (value?: string | null): string =>
  (value ?? "").replace(/[\s-]/g, "");
